import { Theme } from '@mui/material';

export const getTriggerStyling = (
  color: string,
  hoverColor: string,
  _theme: Theme
) => {
  return {
    display: 'inline-block',
    border: 'none',
    padding: 0,
    background: 'transparent',
    cursor: 'pointer',
    borderBottom: `solid ${color} 1px`,
    // need important here to overwrite the color defined in the typography component
    color: `${color} !important`,
    '&:hover': {
      borderBottomColor: hoverColor,
      color: `${hoverColor} !important`,
    },
    '&:hover span': {
      color: `${hoverColor} !important`,
    },
  };
};
